export { initOptic } from './core/initOptic';
export { OpticProvider } from './providers/OpticProvider';
export { useMetricsStore } from './store/metricsStore';
export { useRenderMonitor } from './metrics/reRenders';
export { startTrace, endTrace } from './metrics/trace';
export type { InitOpticOptions } from './core/initOptic';
